import dayjs from "dayjs";

function FormatDate (rawDate, format = "DD.MM.YYYY") {
  return dayjs(new Date(rawDate)).format(format);
}
export default FormatDate;
